import { commonInitProduct, getCommonPageConfig, getCommonPageBatchConfig, getCommonShareConfig, getCommonShareBatchConfig, getCommonCoverConfig, getCommonXaidConfig, commonUpdateWebxUserInfo, getCommonLaunchAppConfig, getCommonLaunchAppStatus, trackCommonLaunchAppEvent, upCommonLaunchAppEvent } from '@didi/webx-js-core';
import { query, hashQuery } from '../query';
import { getBranch } from '../initSDK';
import { post, postEncrypt } from '../request/index';
import { getNineChapterWebxParams } from '../statistic';
import { storage } from '../storage';
function getHostBranch() {
    let branch = getBranch();
    let exhaustiveCheck;
    switch (branch) {
        case 'kfpassenger':
        case 'kfdriver':
            return 'kf';
        case 'cxapp':
        case 'passenger':
        case 'driver':
            return 'didi';
        default:
            exhaustiveCheck = branch; // eslint-disable-line
            return 'didi';
    }
}
const getSessionParams = () => {
    let params = Object.assign({}, query(), hashQuery());
    return {
        root_xpsid: params.root_xpsid,
        f_xpsid: params.f_xpsid
    };
};
const initProduct = async (config, env) => {
    return commonInitProduct(config, env || 'online', getNineChapterWebxParams(false), getSessionParams(), getHostBranch(), getClusterId(), post).then((data) => {
        const nineChapterParamsKey = [
            'dchn',
            'prod_key',
            'xbiz',
            'xpsid',
            'xoid',
            'xspm_from',
            'xpsid_from',
            'xpsid_root',
            'xpsid_share',
            'xpos_from'
        ];
        nineChapterParamsKey.forEach((key) => {
            if (key === 'xpos_from' && data['xpos_from'])
                storage.webxNineChapterParams[key] = encodeURIComponent(JSON.stringify(data['xpos_from']));
            else if (data[key])
                storage.webxNineChapterParams[key] = data[key];
        });
        return data;
    });
};
const getPageConfig = (config, env) => {
    /* 2021-11-16 新增 根据config.args的类型 判断是否需要批量获取 */
    if (config.args &&
        Object.prototype.toString.call(config.args) === '[object Array]') {
        return getCommonPageBatchConfig(config, env || 'online', getNineChapterWebxParams(), getSessionParams(), getHostBranch(), query().preview === 'true', getClusterId(), post);
    }
    else {
        return getCommonPageConfig(config, env || 'online', getNineChapterWebxParams(), getSessionParams(), getHostBranch(), query().preview === 'true', getClusterId(), post);
    }
};
const getShareConfig = (config, env) => {
    /* 2021-11-16 新增 根据config.args的类型 判断是否需要批量获取 */
    if (config.args &&
        Object.prototype.toString.call(config.args) === '[object Array]') {
        return getCommonShareBatchConfig(config, env || 'online', getNineChapterWebxParams(), getSessionParams(), getHostBranch(), getClusterId(), post);
    }
    else {
        return getCommonShareConfig(config, env || 'online', getNineChapterWebxParams(), getSessionParams(), getHostBranch(), getClusterId(), post);
    }
};
const getCoverConfig = (config, env) => {
    return getCommonCoverConfig(config, env || 'online', getNineChapterWebxParams(), getSessionParams(), getHostBranch(), getClusterId(), post);
};
const getXaidConfig = (config, env) => {
    return getCommonXaidConfig(config, env || 'online', getNineChapterWebxParams(), getSessionParams(), getHostBranch(), getClusterId(), post);
};
const updateWebxUserInfo = (config, env) => {
    return commonUpdateWebxUserInfo(config, env || 'online', getNineChapterWebxParams(), getSessionParams(), getHostBranch(), getClusterId(), post);
};
const getLaunchAppConfig = (config, env) => {
    return getCommonLaunchAppConfig(config, env || 'online', getHostBranch(), getClusterId(), postEncrypt);
};
const getLaunchAppStatus = (config, env) => {
    return getCommonLaunchAppStatus(config, env || 'online', getHostBranch(), getClusterId(), postEncrypt);
};
const trackLaunchAppEvent = (config, env) => {
    return trackCommonLaunchAppEvent(config, env || 'online', getHostBranch(), getClusterId(), post);
};
const upLaunchAppEvent = (config, env) => {
    return upCommonLaunchAppEvent(config, env || 'online', getHostBranch(), getClusterId(), post);
};
const getClusterId = () => {
    return Number(query().webx_cluster_id) || 1000;
};
// const getClusterId: IgetClusterId = async (xpsid_root = '') => {
//   if (clusterDict[xpsid_root]) return clusterDict[xpsid_root]
//   if (!crypto.subtle) return 1000
//   const encoder = new TextEncoder()
//   const buffer = encoder.encode(xpsid_root)
//   console.time('crypto.subtle.digest')
//   const hash = await crypto.subtle.digest('SHA-256', buffer)
//   console.timeEnd('crypto.subtle.digest')
//   const bytes = new Uint8Array(hash, 0, 4)
//   bytes.reverse()
//   const int1 = bytes[0]
//   const int2 = bytes[1] << 8
//   const int3 = bytes[2] << 16
//   const int4 = bytes[3] << 24
//   const num = int4 | int3 | int2 | int1
//   const result = Math.abs(num % 1000)
//   clusterDict[xpsid_root] = result
//   return result
// }
export { initProduct, getPageConfig, getShareConfig, getCoverConfig, getXaidConfig, updateWebxUserInfo, getSessionParams, getLaunchAppConfig, getLaunchAppStatus, trackLaunchAppEvent, upLaunchAppEvent };
